import React, { useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../Layout/Sidebar";
import MainContent from "./MainContent";
// import Header from "../Layout/Header";
import "../../styles/homepage.css";

const Homepage = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className="homepage-container">
      {/* <Header /> */}

      <div className={`body-container ${isMobile ? "mobile-layout" : ""}`}>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />

        <div
          className="main-content flex-grow mt-4"
          style={{
            marginLeft: isMobile ? 0 : "280px",
            paddingLeft: isMobile ? "16px" : "24px",
            paddingRight: isMobile ? "16px" : "24px",
            transition: "margin-left 0.3s ease-in-out",
          }}
        >
          <MainContent activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
